module.exports = __webpack_public_path__ + "static/media/5.ef904471.jpg";